import { Injectable } from '@angular/core';
/** Default dropdown configuration */
export class BsDropdownConfig {
    constructor() {
        /** default dropdown auto closing behavior */
        this.autoClose = true;
    }
}
BsDropdownConfig.decorators = [
    { type: Injectable },
];
//# sourceMappingURL=bs-dropdown.config.js.map